'use client';

import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
import { OTPInput, OTPInputContext } from 'input-otp';
import { tv } from 'tailwind-variants';
const inputOTPSlotStyles = tv({
  base: `
    relative flex h-10 w-10 items-center justify-center
    transition-all outline-none
    first:rounded-l-md first:border-l last:rounded-r-md
    data-[active=true]:z-10
    data-[active=true]:ring
  `
});
function InputOTP(t0) {
  const $ = _c(8);
  let className;
  let containerClassName;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      containerClassName,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = containerClassName;
    $[3] = props;
  } else {
    className = $[1];
    containerClassName = $[2];
    props = $[3];
  }
  const t1 = `disabled:cursor-not-allowed ${className ?? ""}`;
  const t2 = `flex items-center gap-2 has-disabled:opacity-50 ${containerClassName ?? ""}`;
  let t3;
  if ($[4] !== props || $[5] !== t1 || $[6] !== t2) {
    t3 = <OTPInput className={t1} containerClassName={t2} data-slot="input-otp" {...props} />;
    $[4] = props;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
}
function InputOTPGroup(t0) {
  const $ = _c(6);
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
  } else {
    className = $[1];
    props = $[2];
  }
  const t1 = `flex items-center ${className ?? ""}`;
  let t2;
  if ($[3] !== props || $[4] !== t1) {
    t2 = <div className={t1} data-slot="input-otp-group" {...props} />;
    $[3] = props;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}
function InputOTPSlot(t0) {
  const $ = _c(17);
  let className;
  let index;
  let props;
  if ($[0] !== t0) {
    ({
      index,
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = index;
    $[3] = props;
  } else {
    className = $[1];
    index = $[2];
    props = $[3];
  }
  const inputOTPContext = React.useContext(OTPInputContext);
  let t1;
  if ($[4] !== index || $[5] !== inputOTPContext?.slots) {
    t1 = inputOTPContext?.slots[index] ?? {};
    $[4] = index;
    $[5] = inputOTPContext?.slots;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  const {
    char,
    hasFakeCaret,
    isActive
  } = t1;
  let t2;
  if ($[7] !== className) {
    t2 = inputOTPSlotStyles({
      className
    });
    $[7] = className;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== hasFakeCaret) {
    t3 = hasFakeCaret && <div className="pointer-events-none absolute inset-0 flex items-center justify-center"><div className="h-4 w-px animate-caret-blink bg-content-primary duration-1000" /></div>;
    $[9] = hasFakeCaret;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== char || $[12] !== isActive || $[13] !== props || $[14] !== t2 || $[15] !== t3) {
    t4 = <div className={t2} data-active={isActive} data-slot="input-otp-slot" {...props}>{char}{t3}</div>;
    $[11] = char;
    $[12] = isActive;
    $[13] = props;
    $[14] = t2;
    $[15] = t3;
    $[16] = t4;
  } else {
    t4 = $[16];
  }
  return t4;
}
function InputOTPSeparator(t0) {
  const $ = _c(5);
  let props;
  if ($[0] !== t0) {
    ({
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <span className="text-content-secondary">-</span>;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== props) {
    t2 = <div data-slot="input-otp-separator" role="separator" {...props}>{t1}</div>;
    $[3] = props;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}
export { REGEXP_ONLY_DIGITS, REGEXP_ONLY_DIGITS_AND_CHARS } from 'input-otp';
export { InputOTP, InputOTPGroup, InputOTPSlot, InputOTPSeparator };